import React from 'react';
import MessageSection from './MessageSection';
import InputSection from './InputSection';
import SproutsIcon from 'src/assets/icons/sprouts-logo.svg';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import QuestionAnswerOutlinedIcon from '@mui/icons-material/QuestionAnswerOutlined';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from 'src/app/rootStore';
import { toggleAudioVisualizer } from 'src/store/sprouts-agent/sprouts-agent.slice';
import { stopAudioPlayback, stopStream } from '../../utils';
import { getThreadId } from 'src/store/sprouts-agent/sprouts-agent.action';
import { sproutsAgentSelector } from 'src/store/sprouts-agent/sprouts-agent.selector';
import Tooltip from 'src/components/Tooltip';
interface ChatProps {
  onClose: () => void;
  show: boolean;
}
const ChatSection: React.FC<ChatProps> = ({ onClose, show }) => {
  const { messages } = useSelector(sproutsAgentSelector);
  const audioRef = React.useRef<HTMLAudioElement | null>(null);
  const handleTimeUpdateRef = React.useRef<(event: Event) => void | null>(null);
  const abortControllerRef = React.useRef<AbortController | null>(null);
  const dispatch = useDispatch<AppDispatch>();
  const handleClose = () => {
    onClose();
    dispatch(toggleAudioVisualizer(false));
    stopStream(dispatch);
    stopAudioPlayback(handleTimeUpdateRef, audioRef, dispatch, abortControllerRef);
    dispatch(toggleAudioVisualizer(false));
  };
  const handleClear = () => {
    stopStream(dispatch);
    dispatch(toggleAudioVisualizer(false));
    stopAudioPlayback(handleTimeUpdateRef, audioRef, dispatch, abortControllerRef);
    dispatch(toggleAudioVisualizer(false));
    dispatch(getThreadId());
  };
  return (
    <div className="chat-container">
      {show && (
        <div className="header">
          <div className="left">
            <img src={SproutsIcon} alt="paula-icon" height={44} width={44} className="sp-icon" />{' '}
            <Tooltip placement="bottom" title={'Minimize'} arrow>
              <span>
                <HomeOutlinedIcon
                  style={{ cursor: 'pointer', color: 'white' }}
                  onClick={handleClose}
                />
              </span>
            </Tooltip>
            {messages?.length > 0 && (
              <Tooltip placement="bottom" title={'New Chat'} arrow>
                <span>
                  <QuestionAnswerOutlinedIcon
                    style={{ cursor: 'pointer', color: 'white' }}
                    onClick={handleClear}
                  />
                </span>
              </Tooltip>
            )}
          </div>
        </div>
      )}
      <div className="left-paula-chat-box">
        <MessageSection
          audioRef={audioRef}
          handleTimeUpdateRef={handleTimeUpdateRef}
          abortControllerRef={abortControllerRef}
        />
        <InputSection
          audioRef={audioRef}
          handleTimeUpdateRef={handleTimeUpdateRef}
          abortControllerRef={abortControllerRef}
        />
      </div>
    </div>
  );
};

export default ChatSection;
